import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "../../app.component";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { element } from "protractor";
import { Subject } from "rxjs";
import { AlertService } from "src/app/alertpopup/_alert";
import { ToastrService } from "ngx-toastr";

export interface FilterData {
  filter: string;
  AdvanceSearch: any;
  Type: string;
  RequestType: string;
}

@Component({
    selector: "app-nav-case-notice",
    templateUrl: "./nav-case-notice.component.html",
    styleUrls: ["./nav-case-notice.component.css"],
    standalone: false
})
export class NavCaseNoticeComponent implements OnInit {
  master: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  pageNumber: number;
  DisplayMessage: string;
  FormSearchNoticeCase: FormGroup;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  RequestFrom: string;
  selectedAll: any;
  isSelected: boolean[];
  RightsID: string;
  selected = [];
  Chkvalue: any;
  pageType: string;
  private searchSubject = new Subject<string>();
  filteredData: any[] = [];
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  monthNumber: any;
  UserID: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private toastr: ToastrService,
  ) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.RightsID = localStorage.getItem("UserRight");
      this.isSelected = [];
      this.pageNumber = 1;
      this.MsgType = 1; // Loading
      this.pageurl = this.router.url;
      let pagehead = this.pageurl.split("/");
      this.advanceSearchValue = "";
      this.RequestFrom = pagehead[4].split("?")[0];
      this.filteredData = [];
      if (pagehead[4] == "UpdateFinalVerdict") {
        this.FetchFinalVerdictList(pagehead[2], "");
      } else {
        this.FetchCase(pagehead[2], "");
      }
      if (pagehead[2] == "notice" || pagehead[2] == "Notice") {
        this.TypeHeader = "Notice";
        this.pageType = "notice";
        if (
          this.RightsID.includes("202030001") ||
          this.RightsID.includes("202030021") ||
          this.RightsID.includes("202030000")
        ) {
        } else {
          window.location.href = "module/0";
        }
      } 
       if (pagehead[2] == "case" || pagehead[2] == "Case") {
        this.pageType = "case";
        this.TypeHeader = "Case";
        if (
          this.RightsID.includes("202032001") ||
          this.RightsID.includes("202032021") ||
          this.RightsID.includes("202032000")
        ) {
        } else {
          window.location.href = "module/0";
        }
      }
      this.FormSearchNoticeCase = this.formBuilder.group({
        txtSearch: [""],
      });
    });
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      if (params.monthNumber) {
        this.monthNumber = params.monthNumber;
        this.UserID = params.UserID;
        this.http
          .get(
            this.url +
              "Notice/GetRecordWithMonthAndUserID?monthNumber=" +
              this.monthNumber +
              "&UserID=" +
              this.UserID
          )
          .subscribe((data) => {
            console.log(data);
            // this.master = data;
          }, error => {
            console.log(error);
          });
      }
    })
    this.initSearch()
  }
  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.pageNumber = 1; 
    this.filterTable('')
  }
  OpenModal(url, cID, modelName, urld) {
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (modelName == "Filter") {
      window.addEventListener("message", this.receiveMessage, false);
      if (this.TypeHeader == "Case") {
        this.modalURL = "filter/202032000";
      } else if (this.TypeHeader == "Notice") {
        this.modalURL = "filter/202030000";
      }
    }
  }
  receiveMessage(event) {
    if (event?.data?.data?.Param != null) {
      localStorage.setItem("advancesearch", event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName("close")[0] as HTMLElement;
      element.click();
    }
  }
  ReturnAdvanceSearch() {
    if (localStorage.getItem("advancesearch") != "") {
      this.advanceSearchValue = JSON.parse(
        localStorage.getItem("advancesearch")
      );
    }
    localStorage.setItem("advancesearch", "");
    this.FetchCase(this.TypeHeader, "");
    this.FetchFinalVerdictList(this.TypeHeader, "");
  }
  onSearchNoticeCase(SearchData) {
    this.FetchCase(this.TypeHeader, SearchData.txtSearch);
    this.FetchFinalVerdictList(this.TypeHeader, SearchData.txtSearch);
  }
  selectAll(page, ischeck) {
    for (let i = 0; i < this.master.length; i++) {
      this.isSelected[i] = false;
    }

    // select all on current page
    for (let i = 2 * (page - 1) + 1; i < 2 * (page - 1) + 2 + 1; i++) {
      if (i <= this.master.length - 1) {
        this.isSelected[i] = ischeck.target.checked;
      }
    }
  }
  DuplicateRecordDelete() {
    //Create an Array.
    this.alertService.showConfirm('Are you sure to Delete Duplicate Ref No?').then((result) => {
      if (result) {
        var DuplicateRecord = "";
        for (let i = 0; i < this.master.length; i++) {
          if (this.master[i].isSelected) {
            if (DuplicateRecord != "") {
              DuplicateRecord += ", ";
            }
            DuplicateRecord += this.master[i].ID;
          }
        }
  
        this.http
          .get(
            this.url +
              "Notice/DeleteDuplicateRecord?DuplicateRecord=" +
              DuplicateRecord
          )
          .subscribe(
            (data) => {
              if (data == null || data.toString() == "[]") {
                this.MsgType = 2; // No Data Found
                this.DisplayMessage = "No Data Found";
                this.master = "";
                this.filteredData = [];
              } else {
                this.MsgType = 0; // No Message
                const res = JSON.parse(data.toString());
                if(res[0].Errmsg == "Record Deleted Successfully" ){
                  this.alertService.showSuccess("Record Deleted Successfully");
                }else{
                  this.toastr.error(res[0].Errmsg,'Error',{timeOut: 5000});
                }
                this.RequestFrom = "DuplicateDelete";
                this.FetchCase("case", "DuplicateDelete");
              }
            },
            (error) => {
              this.MsgType = 3; // Error Message
              this.DisplayMessage = error.message;
            }
          );
      }
    })
  }
  DeleteCase() {
    //Create an Array.
    if (confirm("Are you sure to Delete Case Ref No?")) {
      var DuplicateRecord = "";
      for (let i = 0; i < this.master.length; i++) {
        if (this.master[i].isSelected) {
          if (DuplicateRecord != "") {
            DuplicateRecord += ", ";
          }
          DuplicateRecord += this.master[i].ID;
        }
      }

      this.http
        .get(
          this.url +
            "Notice/DeleteCaseRecord?DeleteCaseRecord=" +
            DuplicateRecord
        )
        .subscribe(
          (data) => {
            if (data == null || data.toString() == "[]") {
              this.MsgType = 2; // No Data Found
              this.DisplayMessage = "No Data Found";
              this.master = "";
            } else {
              this.MsgType = 0; // No Message
              this.master = JSON.parse(data.toString());
              this.filteredData = [...this.master];
              this.RequestFrom = "DeleteCase";
              this.FetchCase("case", "DeleteCase");
            }
          },
          (error) => {
            this.MsgType = 3; // Error Message
            this.DisplayMessage = error.message;
          }
        );
    }
  }

  FetchCase(type, filter) {
    if (this.RequestFrom.toString() == "DuplicateDelete") {
      let filterData: FilterData = {
        filter: filter,
        AdvanceSearch: this.advanceSearchValue,
        Type: type,
        RequestType: this.RequestFrom,
      };
      this.http
        .post(this.url + "Notice/FetchDuplicateRecord", filterData)
        .subscribe(
          (data) => {
            if (data == null || data.toString() == "[]") {
              this.MsgType = 2; // No Data Found
              this.DisplayMessage = "No Data Found";
              this.master = "";
              this.filteredData = [];
            } else {
              this.MsgType = 0; // No Message
              this.master = JSON.parse(data.toString());
              this.filteredData = [...this.master];
              this.filterTable('');
              this.totalRecords = this.master.length;
            }
          },
          (error) => {
            this.MsgType = 3; // Error Message
            this.DisplayMessage = error.message;
          }
        );
    } else if (this.RequestFrom.toString() == "DeleteCase") {
      let filterData: FilterData = {
        filter: "",
        AdvanceSearch: this.advanceSearchValue,
        Type: type,
        RequestType: this.RequestFrom,
      };
      this.http
        .post(this.url + "Notice/FetchDeleteCaseRecord", filterData)
        .subscribe(
          (data) => {
            if (data == null || data.toString() == "[]") {
              this.MsgType = 2; // No Data Found
              this.DisplayMessage = "No Data Found";
              this.master = "";
            } else {
              this.MsgType = 0; // No Message
              this.master = JSON.parse(data.toString());
              this.filteredData = [...this.master];
              this.totalRecords = this.master.length;
              this.filterTable('');
            }
          },
          (error) => {
            this.MsgType = 3; // Error Message
            this.DisplayMessage = error.message;
          }
        );
    } else {
      let filterData: FilterData = {
        filter: filter,
        AdvanceSearch: this.advanceSearchValue,
        Type: type,
        RequestType: this.RequestFrom,
      };
      this.http.post(this.url + "Notice/FetchRecord", filterData).subscribe(
        (data) => {
          if (data == null || data.toString() == "[]") {
            this.MsgType = 2; // No Data Found
            this.DisplayMessage = "No Data Found";
            this.master = "";
            this.filteredData = [];
          } else {
            this.MsgType = 0; // No Message
            this.master = JSON.parse(data.toString());
            this.filteredData = [...this.master];
            this.totalRecords = this.master.length;
            this.filterTable('');
          }
        },
        (error) => {
          this.MsgType = 3; // Error Message
          this.DisplayMessage = error.message;
        }
      );
    }
  }

  // Fetch Final Verdic start
  FetchFinalVerdictList(type, filter) {
    if (this.RequestFrom.toString() == "UpdateFinalVerdict") {
      let filterData: FilterData = {
        filter: filter,
        AdvanceSearch: this.advanceSearchValue,
        Type: type,
        RequestType: this.RequestFrom,
      };
      this.http
        .post(this.url + "Notice/FetchFinalVerdict", filterData)
        .subscribe(
          (data) => {
            if (data == null || data.toString() == "[]") {
              this.MsgType = 2; // No Data Found
              this.DisplayMessage = "No Data Found";
              this.master = "";
              this.filteredData = [];
            } else {
              this.MsgType = 0; // No Message
              this.master = JSON.parse(data.toString());
              this.filteredData = [...this.master];
              this.filterTable('');
              this.totalRecords = this.master.length;
            }
          },
          (error) => {
            this.MsgType = 3; // Error Message
            this.DisplayMessage = error.message;
          }
        );
    }
  }

  onSearch(value) {
    this.searchSubject.next(value.trim().toLowerCase());
  }
  initSearch() {
    this.searchSubject
      .pipe(
        debounceTime(300),       
        distinctUntilChanged()
      )
      .subscribe(searchText => {
        this.filterTable(searchText);
      });
  }
  filterTable(searchText: string) {
    if (!searchText) {
      this.filteredData = [...this.master];
      return;
    }

    this.filteredData = this.master.filter(row =>
      Object.values(row).some(val =>
        val?.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
    this.pageNumber = 1;
  }
  ngOnDestroy() {
    this.searchSubject.complete();
  }
}
